import { render, staticRenderFns } from "./PORTFOLIOCOMMENT.vue?vue&type=template&id=a97f9990"
import script from "./PORTFOLIOCOMMENT.vue?vue&type=script&lang=js"
export * from "./PORTFOLIOCOMMENT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports